// Fermer une modale en cliquant sur son fond — sans fermer sur un geste.
//
// `onClick={onClose}` sur le voile ne suffit pas. Quand on presse le bouton
// DANS la modale (selection d'un texte, glissement d'un curseur) et qu'on
// relache en dehors, le navigateur emet malgre tout un « click », dispatche sur
// le premier ancetre commun aux deux points — c'est-a-dire le voile. La modale
// se fermait donc en plein milieu d'une saisie, et tout etait a refaire.
// stopPropagation sur le contenu n'y peut rien : l'evenement ne passe pas par
// lui, il nait sur le voile.
//
// On exige donc que le geste COMMENCE et FINISSE sur le voile.
//
// L'etat est pose sur l'element du DOM et non dans une variable de fermeture :
// un rendu React entre le mousedown et le click la reinitialiserait, et la
// modale redeviendrait increvable.
export function fermetureFond(onClose) {
  return {
    onMouseDown: (e) => {
      if (e.currentTarget) e.currentTarget.dataset.fondPresse = String(e.target === e.currentTarget);
    },
    onClick: (e) => {
      const presseSurLeFond = e.currentTarget?.dataset.fondPresse === 'true';
      if (e.currentTarget) delete e.currentTarget.dataset.fondPresse;
      if (presseSurLeFond && e.target === e.currentTarget) onClose(e);
    },
  };
}
